import { Volume2 } from 'lucide-react';
import { useAppStore } from '@/stores/useAppStore';

export function VoiceSettingsContent() {
  const { settings, updateSettings } = useAppStore();
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-coral-100 flex items-center justify-center">
          <Volume2 size={16} className="text-coral-600" />
        </div>
        <h3 className="font-display font-semibold text-warm-800">音声設定</h3>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-warm-700 mb-1.5">ElevenLabs API Key</label>
          <input
            type="password"
            value={settings.elevenLabsApiKey}
            onChange={(e) => updateSettings({ elevenLabsApiKey: e.target.value })}
            className="input-base"
            placeholder="sk-..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-warm-700 mb-1.5">
            声の安定性
          </label>
          <div className="flex items-center gap-3">
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={settings.voiceStability}
              onChange={(e) => updateSettings({ voiceStability: parseFloat(e.target.value) })}
              className="flex-1 h-1.5 bg-warm-200 rounded-full appearance-none cursor-pointer accent-coral-500"
            />
            <input
              type="number"
              min="0"
              max="1"
              step="0.01"
              value={settings.voiceStability}
              onChange={(e) => {
                const parsed = parseFloat(e.target.value);
                // 入力途中の空欄などを0として確定させない
                if (Number.isNaN(parsed)) return;
                const value = Math.min(1, Math.max(0, parsed));
                updateSettings({ voiceStability: value });
              }}
              className="w-20 px-2 py-1 text-sm font-medium text-warm-600 text-right border border-warm-200 rounded-md bg-white focus:outline-none focus:border-coral-300"
            />
          </div>
          <div className="flex justify-between text-xs text-warm-400 mt-1">
            <span>表現豊か</span>
            <span>安定</span>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-warm-700 mb-1.5">
            声の鮮明さ
          </label>
          <div className="flex items-center gap-3">
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={settings.voiceSimilarityBoost}
              onChange={(e) => updateSettings({ voiceSimilarityBoost: parseFloat(e.target.value) })}
              className="flex-1 h-1.5 bg-warm-200 rounded-full appearance-none cursor-pointer accent-coral-500"
            />
            <input
              type="number"
              min="0"
              max="1"
              step="0.01"
              value={settings.voiceSimilarityBoost}
              onChange={(e) => {
                const parsed = parseFloat(e.target.value);
                // 入力途中の空欄などを0として確定させない
                if (Number.isNaN(parsed)) return;
                const value = Math.min(1, Math.max(0, parsed));
                updateSettings({ voiceSimilarityBoost: value });
              }}
              className="w-20 px-2 py-1 text-sm font-medium text-warm-600 text-right border border-warm-200 rounded-md bg-white focus:outline-none focus:border-coral-300"
            />
          </div>
          <div className="flex justify-between text-xs text-warm-400 mt-1">
            <span>なめらか</span>
            <span>くっきり</span>
          </div>
        </div>
      </div>
    </div>
  );
}
